export default "__VITE_ASSET__COotL5Hd__"